<script lang="ts" setup>
import dayjs from '@sancare/typescript-commons/src/misc/dayjs'
import { computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'

import { useStore } from '@/store'

const { t } = useI18n()
const store = useStore()

const appVersion = import.meta.env.VITE_APP_VERSION
const appBuildDate = dayjs(import.meta.env.VITE_APP_BUILD_DATE)

const predictionModels = computed(() => store.state.home.predictionModels)
const isLoading = computed(() => store.state.home.requests.getPredictionModels.fetching)

onMounted(() => {
  store.dispatch('home/getPredictionModels')
})
</script>

<template>
  <div class="container">
    <div class="card">
      <div class="card-body">
        <h1 class="mb-4">
          {{ t('about.title') }}
        </h1>
        <ul class="px-2 border-bottom">
          <li class="row border-top py-3">
            <div class="col-3 fw-bold">
              {{ t('about.interfaceVersion') }}
            </div>
            <div class="col-2">
              {{ appVersion }}
            </div>
            <div class="col-2">
              {{ t('about.updatedAt') }} {{ appBuildDate.format('DD-MM-YYYY') }}
            </div>
          </li>
          <li
            v-if="isLoading"
            class="row border-top py-3"
          >
            <div class="col-2">
              <div class="loader loader-lg loader-center" />
            </div>
          </li>
          <template v-else>
            <li
              v-for="model in predictionModels"
              :key="`${model.name}-${model.version}`"
              class="row border-top py-3"
            >
              <div class="col-3 fw-bold">
                {{ t('about.predictionModelVersion', { name: model.name }) }}
              </div>
              <div class="col-2">
                {{ model.version }}
              </div>
              <div class="col-2">
                {{ model.trainedAt ? `${t('about.updatedAt')} ${model.trainedAt.format('DD-MM-YYYY')}` : '' }}
              </div>
            </li>
            <li
              v-if="predictionModels.length === 0"
              class="row border-top py-3"
            >
              <div class="col-2">
                {{ t('about.noPredictionModel') }}
              </div>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
h1 {
  font-size: 1.5rem;
}
</style>